import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=e6d5cac6&scoped=true&"
import script from "./Dropzone.vue?vue&type=script&lang=js&"
export * from "./Dropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d5cac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d5cac6')) {
      api.createRecord('e6d5cac6', component.options)
    } else {
      api.reload('e6d5cac6', component.options)
    }
    module.hot.accept("./Dropzone.vue?vue&type=template&id=e6d5cac6&scoped=true&", function () {
      api.rerender('e6d5cac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/audios/Dropzone.vue"
export default component.exports